module.exports = __webpack_public_path__ + "img/full0-min.77eb5fc3.png";